import React, { useEffect, useRef } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { WebService } from "../../../Services/WebService";
import {
  Form,
  FormInputText,
  FormInputDropdown,
  FormCheckRadioInput,
} from "../../Form";
import * as yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import "./../Payslip.css";
import _, {
  extendOwn,
  filter,
  findWhere,
  map,
  omit,
  sortBy,
} from "underscore";
import DisplayNumberFormatComponent from "../../../Services/DisplayNumberFormatComponent";
import { StandardConst } from "../../../Services/StandardConst";

const { forwardRef, useState, useImperativeHandle } = React;
const AddEditTemplate = (prop, ref) => {
  const [show, setShow] = useState(false);
  const [temaplateDisabled, setTemaplateDisabled] = useState(false);
  const [data, setData] = useState({ Payslip: {} });
  const [checked, setChecked] = useState(true);
  const [projects, setProjects] = useState([{ value: 0, text: "" }]);
  const afterRender = useRef(false);
  const formRef = useRef();
  const dispatch = useDispatch();
  useImperativeHandle(ref, () => ({
    openModal: async (id, templateId = null) => {
      const data = await WebService({
        dispatch,
        endPoint: `SalaryTemplateComp/Fetch/${id || 0}`,
      });
      await fetchTemplateComponent(
        data?.component?.TemplateId ?? 0,
        data?.component?.SalaryComponentId ?? 0
      );
      data.salary = data.salary.map((v) => {
        return {
          value: v.TemplateId,
          text: v.TemplateName,
        };
      });
      data.static = data.static.map((v) => {
        return {
          value: v.SalaryComponentsId,
          text: v.EarningOrDeductionName,
        };
      });
      data.calculation = data.calculation.map((v) => {
        return {
          value: v.CalculationMethodId,
          text: v.CalculationMethod,
        };
      });
      data.TemplateComponentId = data.component.TemplateComponentId;
      data.NumberOrAmount = data.component.NumberOrAmount;
      data.CalculationMethodId = data.component.CalculationMethodId;
      data.SalaryComponentId = data.component.SalaryComponentId;
      data.TemplateId = data.component.TemplateId ?? templateId;
      data.IsDependentOnCTC = data.component.IsDependentOnCTC == 1;
      data.DependentOnComponentId = data.IsDependentOnCTC ? 0 : data.component.DependentOnComponentId;
      setData(data);
      setTemaplateDisabled(true);
      setShow(true);
    },
  }));

  // useEffect(() => {
  //   if (!afterRender.current) {
  //     fetchTemplateComponent();
  //   }
  //   afterRender.current = true;
  // }, []);
  const [componentDependentOptions, setComponentDependentOptions] = useState(
    []
  );
  const fetchTemplateComponent = async (
    TemplateId = null,
    SalaryComponentId = data?.SalaryComponentId
  ) => {
    if ((data?.salary ?? []).length > 0) TemplateId ??= data.salary[0].value;
    if ((data?.static ?? []).length > 0)
      SalaryComponentId ??= data.static[0].value;
    var s1 = await WebService({
      dispatch,
      endPoint: `SalaryTemplateComp/FetchDepend/${TemplateId ?? 0}`,
    }).then((c) => {
      var a1 = filter(
        c ?? [],
        (f) => f.SalaryComponentId != (SalaryComponentId ?? 0)
      );
      return map(a1, (m) => {
        return {
          value: m.TemplateComponentId,
          text: m.EarningOrDeductionName,
        };
      });
    });
    setComponentDependentOptions([{ value: 0, text: "CTC" }].concat(s1));
  };
  const handleClose = () => setShow(false);
  const requiredMessage = "This is a required field";
  const schema = yup
    .object()
    .shape({
      TemplateId: yup.string().trim().required(requiredMessage),
      SalaryComponentId: yup.string().trim().required(requiredMessage),
      CalculationMethodId: yup.string().trim().required(requiredMessage),
      NumberOrAmount: yup
        .number()
        .label("Value")
        .typeError("Invalid value")
        .required(requiredMessage)
        .min(0)
        .when(["CalculationMethodId"], (methodId, passSchema) => {
           // 🔹 Manual (4) → not required
        if (methodId?.length > 0 && String(methodId[0]) === "4") {
          return passSchema.notRequired();
        }

        // 🔹 Required for all others
        let schemaWithRules = passSchema
          .required(requiredMessage)
          .min(0);

          if (methodId.length > 0 && methodId[0] == 1) {
            return schemaWithRules.max(100);
          } else {
            return schemaWithRules;
          }
        }),
    })
    .required();
  const onSubmit = async (data) => {
    if (parseInt(data.DependentOnComponentId) === StandardConst.defaultIntValue) {
      data.DependentOnComponentId = null;
    }
    data.IsDependentOnCTC = data?.IsDependentOnCTC ?? false ? 1 : 0;
    data = omit(data, ["salary", "static", "component", "calculation"]);
    let endPoint = "SalaryTemplateComp";
    let method = "POST";
    if ((data.TemplateComponentId ?? 0) !== 0) {
      endPoint = `SalaryTemplateComp/${data.TemplateComponentId}`;
      method = "PUT";
    }
    await WebService({ dispatch, endPoint, body: data, method });
    // console.log(JSON.stringify(data));
    handleClose();
    prop.callBackEvent();
  };
  // useEffect(()=>{
  //   if(show==false){
  //     setComponentDependentOptions([]);
  //   }
  // },[show]);
  var dependent = (
    <div className="col-md-12">
      <FormInputDropdown
        name="DependentOnComponentId"
        ddOpt={componentDependentOptions ?? []}
        label="Dependent On"
        setValue={(v) => setData({ ...data, DependentOnComponentId: v })}
      ></FormInputDropdown>
    </div>
  );
  const ctcStatusChange = async () => {
    if (parseInt(data.DependentOnComponentId ?? "0") === 0) {
      if (!(data?.IsDependentOnCTC ?? false)) {
        setData({ ...data, IsDependentOnCTC: true });
        await formRef.current.fnReset((data) => ({ ...data, IsDependentOnCTC: true }));
      }
    }
    else {
      if ((data?.IsDependentOnCTC ?? false)) {
        setData({ ...data, IsDependentOnCTC: false });
        await formRef.current.fnReset((data) => ({ ...data, IsDependentOnCTC: false }));
      }
    }
  }
  useEffect(() => {
    ctcStatusChange();
  }, [data.DependentOnComponentId]);
  const DependentOnComponentIdChangeOnCTC = async () => {
    if ((data?.IsDependentOnCTC ?? false) && parseInt(data.DependentOnComponentId ?? "0") !== 0) {
      setData({ ...data, DependentOnComponentId: 0 });
      await formRef.current.fnReset((data) => ({ ...data, DependentOnComponentId: 0 }));
    }
  }
  useEffect(() => {
    DependentOnComponentIdChangeOnCTC();
  }, [data.IsDependentOnCTC, componentDependentOptions]);

  const companyInfo = useSelector((s) => s.auth.CompanyInfo ?? {});
  const [companyCurrentSymbol, setCompanyCurrencySymbol] = useState("");

  const fetchCurrentSymbolOfCompany = async () => {
    const companyInformation = await WebService({
      endPoint: `CommonUtility/Edit/companyinformation?CompanyId=${companyInfo.CompanyId || 0}`,
      dispatch,
    }).then((c) => (c.length > 0 ? c[0] : {}));
    const currencyInformation = await WebService({
      endPoint: `CommonUtility/Edit/staticcurrency?CurrencyId=${companyInformation.CurrencyId || 0}`,
      dispatch,
    }).then((c) => (c.length > 0 ? c[0] : {}));
    setCompanyCurrencySymbol(currencyInformation.Symbol);
  };

  useEffect(() => {
    fetchCurrentSymbolOfCompany();
  }, [companyInfo.CompanyId, companyCurrentSymbol])

  return (
    <Modal
      show={show}
      onHide={handleClose}
      className="container-fluid"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {(data.TemplateComponentId || 0) === 0
            ? "Add Salary Head"
            : "Edit Salary Head"}
        </Modal.Title>
      </Modal.Header>
      <Form
        ref={formRef}
        defaultValues={data}
        onSubmit={onSubmit}
        validationSchema={schema}
      >
        <Modal.Body className="p-4">
          <div className="row">
            <div className="col-md-12 hide">
              <FormInputDropdown
                name="TemplateId"
                ddOpt={data.salary}
                label="Template Name"
                isRequired="true"
                setValue={async (v) => {
                  setData({ ...data, TemplateId: v });
                  await fetchTemplateComponent(v);
                }}
                disabled={temaplateDisabled}
              ></FormInputDropdown>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <FormInputDropdown
                name="SalaryComponentId"
                ddOpt={data.static}
                label="Salary Head Name"
                isRequired="true"
                setValue={async (v) => {
                  setData({ ...data, SalaryComponentId: v });
                  await fetchTemplateComponent(data.TemplateId, v);
                }}
              ></FormInputDropdown>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <FormInputDropdown
                name="CalculationMethodId"
                // ddOpt={sortBy(data.calculation, (f) => f.text)}
                ddOpt = {
                  sortBy(
                    data.calculation,
                    (f) => {
                      console.log(f.text);
                      return f.text;
                    }
                  )
                }
                label="Calculation Method"
                isRequired="true"
                setValue={(v) => {
                  console.log('selected', v);
                  const selectedValue = Number(v); // 👈 IMPORTANT
                  const isManual = selectedValue === 4;
                  //  const isManual = v === 4;
                    const val = {
      CalculationMethodId: v,
      NumberOrAmount: isManual ? null : data?.NumberOrAmount,
    };

                  // var val = { CalculationMethodId: v, NumberOrAmount: null };
                  if (v == 2 && (data?.IsDependentOnCTC ?? false) != false) {
                    extendOwn(val, { IsDependentOnCTC: false });
                  } else if ((data?.IsDependentOnCTC ?? false) != true) {
                    extendOwn(val, { IsDependentOnCTC: true });
                  }
                  setData({ ...data, ...val });
                  formRef.current.fnReset({ ...data, ...val });
                }}
              ></FormInputDropdown>
            </div>
          </div>
          {console.log(data?.CalculationMethodId,'hhhhhhhh')}
          {console.log(data?.calculation,'kkkk')}
          {Number(data?.CalculationMethodId) !== 4 && (
          <div className="row">
            <div className="col-md-12">
              <FormInputText
                label="Number/Amount"
                name="NumberOrAmount"
                type="number"
                // isRequired= "true"
                 isRequired={Number(data?.CalculationMethodId) !== 4}
                value={data?.NumberOrAmount ?? 0}
                setValue={(v) => setData({ ...data, NumberOrAmount: v })}
        //         {...(Number(data?.CalculationMethodId) !== 4 && {
        //   isRequired: true,
        // })}
              />
            </div>
          </div>
        )} 
          <div className="row">
            <div className="col-md-12">
              {(data?.CalculationMethodId ??
                ((data?.calculation ?? []).length > 0
                  ? data.calculation[0]["value"]
                  : null)) == 1 && (
                  <>
                    <div className="col-md-12" style={{ display: "none" }}>
                      <FormCheckRadioInput
                        label="Dependent On CTC"
                        name="IsDependentOnCTC"
                        isRequired="true"
                        isRadio={false}
                        value={data?.IsDependentOnCTC ?? false}
                        setValue={(v) => {
                          setData({ ...data, IsDependentOnCTC: v });
                        }}
                      />
                    </div>
                    {dependent}
                    <div className="col-md-12" style={{ color: "blue" }}>
                      <label>
                        {findWhere(data.static, {
                          value: parseInt(
                            data.SalaryComponentId ??
                            (data.static.length > 0 ? data.static[0].value : "0")
                          ),
                        })?.text ?? ""}{" "}
                        = {data?.NumberOrAmount ?? 0}% of{" "}
                        {data.IsDependentOnCTC
                          ? "CTC"
                          : findWhere(componentDependentOptions, {
                            value: parseInt(data.DependentOnComponentId ?? "0"),
                          })?.text}
                      </label>
                    </div>
                  </>
                )}
              {!(
                (data?.CalculationMethodId ??
                  ((data?.calculation ?? []).length > 0
                    ? data.calculation[0]["value"]
                    : null)) == 1
              ) && (data?.static ?? []).length > 0 && (
                  <>
                    <div className="col-md-12" style={{ color: "blue" }}>
                      <label>
                        {findWhere(data?.static ?? [], {
                          value: parseInt(
                            data?.SalaryComponentId ??
                            (data.static.length > 0 ? data.static[0].value : "0")
                          ),
                        })?.text ?? ""}{" "}
                        ={" "}
                        <DisplayNumberFormatComponent
                          Number={data?.NumberOrAmount ?? 0}
                          Currency={companyCurrentSymbol}
                        />
                      </label>
                    </div>
                  </>
                )}
            </div>
          </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-primary" type="submit">
          {(data.TemplateComponentId || 0) === 0 ? "Submit" : "Save Changes"}
        </Button>
      </Modal.Footer>
    </Form>
    </Modal >
  );
};

export default forwardRef(AddEditTemplate);
